interface LoginErrorModelInterface {
  phone?: string;
  password?: string;
  confirmPassword?: string;
}
export class LoginErrorModel {
  phone?: string;
  password?: string;
  confirmPassword?: string;

  constructor(data: LoginErrorModelInterface = {}) {
    this.phone = data.phone || "";
    this.password = data.password || "";
    this.confirmPassword = data.confirmPassword || "";
  }
}
